import { uniqueKey } from 'global/common/keys'
import _ from 'lodash'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gameScoringTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import React, { useContext, useMemo, useState } from 'react'
import { SportsStandingsContext } from './LeagueStandings'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { Icon } from 'semantic-ui-react'
import { SectionHeaders } from 'projectSpecific/sports/elements/standings/SectionHeaders'
import { TeamSectionRecord } from './TeamSectionRecord'
import { sortingHelpers, updateArrayInclusion } from 'global/common/sorting'
import { CreatePlayoffContext } from 'projectSpecific/sports/create/CreatePlayoff'
import { motion } from "framer-motion";
import MotionDiv from 'global/motions/MotionDiv'
import { setKey } from 'react-geocode'
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters'

export const SectionStandingz = ({
  levelKey,
  teamKey,
  matchSections,
  matchKey,
  _teamsFavs,
  sectionOpts,
  forOverview,
  caption,
}) => {

  const { forPlayoff, availableTeams } = sectionOpts ?? {}

  const parentContext = useContext(ParentContext);
  const { fns, states } = parentContext ?? {}
  const { appUser_state } = states ?? {}
  const { navigation_fns } = fns

  const { appUser } = appUser_state ?? {}
  const { profileData } = appUser ?? {}
  const { favs_info } = profileData ?? {}
  const { eventFavs } = favs_info ?? {};
  const team_favs = eventFavs && eventFavs['teams']

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { currentSeason_info, teams_info, matches_info, details_info, sportSettings_info, sportsShowType, links_score } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { matches, matches_playoffs } = matches_info ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { sortStandingsByPoints } = links_score ?? {}

  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { playoffTeams: playoffTeams_season } = teams_info ?? {}
  const { details, sectionPlayoffTeams } = details_info ?? {}
  const { playoffTeamsPerSection } = details ?? {}

  const sportsStandingsContext = useContext(SportsStandingsContext)
  const { sportsStandings_state, sportsStandings_handlers } = sportsStandingsContext ?? {}
  const { showSelected, selected_teams, showPlayoffPicture } = sportsStandings_state ?? {}

  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}

  const { sortSectionStandings } = useSportsFilters({ sportsSeason_state })

  const [selected_team, setSelectedTeam] = useState()
  const [showRemaining, setShowRemaining] = useState()
  const handleShowRemaining = () => setShowRemaining(!showRemaining)

  const handleSelectedTeams = (team) => {
    const _sts = [...selected_teams]
    updateArrayInclusion(_sts, team._itemKey)
    sportsStandings_handlers.handleSet_selected_teams(_sts)
  }

  const handlePlayoffClick = (e, team, compareOnly) => {
    if (e) { e.cancelBubble = true };
    if (e && e.stopPropagation) e.stopPropagation();
    createPlayoff_handlers.handleSelect_playoffTeam(team, compareOnly)
  }

  const handleSelectClick = (e, team) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    handleSelectedTeams(team)
  }

  const handleTeamClick = (e, team) => {
    if (forPlayoff) {
      _allowSelect && setSelectedTeam(selected_team ? null : team)
      createPlayoff_handlers.handleSelect_playoffTeamRecord(team)
      if (allowSelect) {
        allowSelect && handlePlayoffClick(e, team, true)
      }
    } else {
      team && navigation_fns && sportsSeason_handlers.handleGoTo_team(navigation_fns, team)
    }
  }

  // console.log('sportsSeason_state', sportsSeason_state)
  const isNonSection = false

  const tableType = 'tst'

  let valueW = 2

  const motion_wrapper = (content) => <MotionDiv>
    {content}
  </MotionDiv>

  const getSortedTeams = (teams) => {
    if (sortSectionStandings && teams) {
      return sortSectionStandings(
        teams,
        playoffTeamsPerSection,
        sectionPlayoffTeams,
        _sportsModeSport,
        forPlayoff,
        sortStandingsByPoints
      );
    }
    return [];
  };

  const getSelectedStandings = (selectedTeam, sectionTeams) => {
    const _selected = []
    const _teams = Object.values(sectionTeams)
    const index = _.findIndex(_teams, { _itemKey: selectedTeam });
    let _indexes = []
    if (index === 0) {
      _indexes = [0, 1, 2]
    } else if (index === _.size(sectionTeams) - 1) {
      _indexes = [index - 2, index - 1, index]
    } else {
      _indexes = [index - 1, index, index + 1]
    }
    _.forEach(_indexes, idx => {
      _selected.push(_teams[_indexes[idx]])
    })
    return _selected;
  }


  const standingsHeader = SectionHeaders({ gameScoringType, tableType, isNonSection, gameAllowTies })

  const standingsTable = (teams, sectionKey) => {
    if (_.isEmpty(teams)) { return }
    let _teams = teams
    if (forOverview) {
      const _teamz = getSelectedStandings(teamKey, teams)
      _teams = _teamz
      console.log('_teamz', _teamz)
    }
    const sortedTeams = getSortedTeams(_teams)
    const rows = []
    let rowIndex = 0;
    _.forEach(sortedTeams, (team, teamKey) => {
      const rowKey = 'r' + rowIndex
      rows.push(<TeamSectionRecord
        isNonSection={isNonSection}
        tableType={tableType}
        valueW={valueW}
        team={team}
        rowKey={rowKey}
        team_favs={team_favs}
        forPlayoff={forPlayoff}
        handleTeamClick={handleTeamClick}
      />)
    })
    return rows
  }

  let cn = 'standings-container'
  let cnt = 'standings-table '

  switch (gameScoringType) {
    case gameScoringTypes.half:
      cnt += ' ties'
      break;
    default:
      cnt += ' no-ties'
      break;
  }

  if (gameScoringType === gameScoringTypes.matchPoints) {
    cnt += ' pts'
  }

  function isFavInSection(teams, _teamsFavs) {
    let isFav;
    Object.keys(_teamsFavs).forEach(tf => {
      const stf = _.find(teams, { _itemKey: tf })
      if (stf) { isFav = true }
    })
    return isFav
  }

  const levelSections = (lk) => {
    const levelTeams = _.groupBy(teams, 'levels')
    const _team = teamKey ? teams?.[teamKey] : {}
    const { sections, levels } = _team ?? {}
    const level_key = teamKey && levels ? levels : lk
    const _levelTeams = levelTeams?.[level_key]
    const _sectionTeams = _.groupBy(_levelTeams, 'sections')
    if (teamKey) {
      return { _levelKey: level_key, currentSection: { [sections]: _sectionTeams[sections] } }
    } else {
      return { _levelKey: level_key, currentSection: _sectionTeams }
    }
  }


  const levelSectionStandings = useMemo(() => {

    const { _levelKey, currentSection } = levelSections(levelKey)
    const _currentSections = sortingHelpers.sortByKey(currentSection)

    // loop the section in the level
    const _sectionTables = _.map(_currentSections, (teams, sectionKey) => {

      const isFavSection = _teamsFavs && isFavInSection(teams, _teamsFavs)
      const caption = _levelKey + ' - ' + _.startCase(sectionKey)

      const sl = `${levelKey}-${sectionKey}`
      if (matchSections && !_.includes(matchSections, sl)) { return; }

      return <div className={cn} key={uniqueKey('ss', 'shw', levelKey, sectionKey)}>
        <div key={uniqueKey('ss', 'sh', levelKey, sectionKey)} className={'standings-header'}>
          {isFavSection ? <div><Icon name={'star'} color={'blue'} /></div> : <div></div>}
          {caption}
          <div><Icon name='calendar outline' color={showRemaining ? 'blue' : 'grey'} onClick={(e) => { handleShowRemaining(e) }} /></div>
        </div>
        <div className={cnt}>
          <div className='match-date-matches'>
            <MotionDiv origin='sectionStandingz'>
              <div>{standingsHeader}</div>
              {standingsTable(teams, sectionKey)}
            </MotionDiv>
          </div>
        </div>
      </div >
    })
    return _sectionTables
  }, [levelKey])

  return <div className='standings-container-legend'>
    {levelSectionStandings}
  </div>
}
